import { render, staticRenderFns } from "./monitorInfo.vue?vue&type=template&id=13db34ba"
import script from "./monitorInfo.vue?vue&type=script&lang=js"
export * from "./monitorInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports